// Import Packages
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Import Material UI
import { Box } from "@material-ui/core";

// Import Pages
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';


function TabPanel({ children, value, index }) {
    return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function RenameFolders({ action, variables, setOpenVariable, automId, showAlert }) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.FTP-SFTP.RENAME-FOLDERS.";


    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "FOLDER-PATH")} is_required={true} />
                <TextInput
                    action={action}
                    inputName="folderPaths"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                    hideRequired={true}
                />
                <small
                    className="conf-field-desc"><em>{t(label + 'FOLDER-PATH-HELP')}</em></small>
            </div>

            <div className="conf-field-container">
                <FieldLabel name={t(label + "NEW-FOLDER-NAME")} is_required={true} />
                <TextInput
                    action={action}
                    inputName="newFolderName"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={true}
                    hideRequired={true}
                />
                <small
                    className="conf-field-desc"><em>{t(label + 'NEW-FOLDER-NAME-HELP')}</em></small>
            </div>

        </div>
    );
}

export default RenameFolders;